import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit, output} from '@angular/core';
import {QueryBlockFilter, QueryBlockItem, QueryBlockOperator} from '../../../models/query-block';
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDragPreview, CdkDropList} from '@angular/cdk/drag-drop';
import {QueryHelperService} from '../../../helper/query-helper.service';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {SearchQueryKeywordComponent} from '../search-query-keyword/search-query-keyword.component';
import {
  SearchQueryOperatorToggleComponent
} from '../search-query-operator-toggle/search-query-operator-toggle.component';

@Component({
  selector: 'app-search-keyword-item',
  imports: [
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    CdkDragPreview,
    AsyncPipe,
    SearchQueryKeywordComponent,
    SearchQueryOperatorToggleComponent,
  ],
  templateUrl: './search-keyword-item.component.html',
  styleUrl: './search-keyword-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchKeywordItemComponent implements OnInit {
  private readonly queryHelperService: QueryHelperService = inject(QueryHelperService);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  item = input.required<QueryBlockItem>();
  parentItem = input<QueryBlockItem>();
  allDropListsIds = input<string[]>([]);

  itemDrop = output<CdkDragDrop<QueryBlockItem>>();
  itemDeleted = output<QueryBlockItem>();
  updated = output<void>();


  dragStarted$: Observable<boolean> = this.queryHelperService.dragStarted$;

  blockColor: string = '';

  ngOnInit() {
    this.blockColor = this.queryHelperService.getBlockColor(this.item().uId)
  }

  public get connectedDropListsIds(): string[] {
    return this.allDropListsIds().filter((id) => id !== this.item().uId);
  }

  public get parentItemId(): string {
    return this.parentItem() ? this.parentItem()!.uId : this.item().uId;
  }

  public deleteItem(item: QueryBlockItem){
    this.itemDeleted.emit(item);
  }

  public onDragDrop(event: CdkDragDrop<any, any>): void {
    this.itemDrop.emit(event);
  }

  setDragStarted(started: boolean): void {
    this.queryHelperService.setDragStarted(started);
  }
  public filterChange(filter?: QueryBlockFilter | undefined){
    this.item().filter = filter;
    this.updated.emit();
  }
  public operatorChange(operator: QueryBlockOperator){
    this.item().operator = operator;
    this.updated.emit();
  }

}
